const scope = "realizedGL";
export default scope;
